(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAuswahl', {
            require: {
                form: '^form'
            },
            bindings: {
                model: '<abaModel',
                text: '@abaText',
                onChange: '&?abaOnChange',
                isOpen: '=?abaIsOpen',
                disabled: '<?abaDisabled',
                options: '<abaOptions'
            },
            transclude: {
                content: '?content'
            },
            templateUrl: 'bloecke/sonstiges/blockAuswahl.html',
            controller: BlockAuswahlController,
            controllerAs: 'blockAuswahlVm'
        });

    BlockAuswahlController.$inject = [
        '$scope',
        '$transclude',
        '$modal',
        '$element',
        '$analytics',
        'lodash'
    ];
    function BlockAuswahlController($scope, $transclude, $modal, $element, $analytics, _) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.getButtonLabel = getButtonLabel;
        vm.onChanged = onChanged;
        vm.onOpen = onOpen;
        vm.onClose = onClose;

        function activate() {
            vm.options = vm.options || {};

            vm.gridLayoutCss = vm.options.grid || {};
            vm.hasContentTransclude = $transclude.isSlotFilled('content');

            vm.hasContent = (
                vm.hasContentTransclude
            );

            vm.trackingName = $element[0].getAttribute('data-wgvt-name');
        }

        function onChanges() {
            activate();
        }

        function onInit() {
            activate();
        }

        function getButtonLabel() {
            return vm.model ? 'Ausgewählt' : 'Auswählen';
        }

        function onChanged($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.disabled) {
                $scope.$emit('iplusjs:showModalAngebotNichtAenderbar');
                return;
            }

            if (vm.model === false) {
                vm.isOpen = true;
            }

            if (angular.isFunction(vm.onChange)) {
                vm.onChange({ value: !vm.model });
            }
        }

        function onOpen() {
            if (!vm.hasContent) {
                return;
            }

            if (vm.isOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: vm.trackingName,
                    value: 'open'
                });
            }
        }

        function onClose() {
            if (!vm.hasContent) {
                return;
            }

            if (vm.isOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: vm.trackingName,
                    value: 'close'
                });
            }
        }
    }

})();
